module.exports = __webpack_public_path__ + "images/filter-icon-2-27e28061.svg";